/**
 * Turns a stored floorplan `imageUrl` into something an `<img src>` can load.
 *
 * The admin builder saves whatever Helix's `/images/upload` returns in `path`, which is a
 * *relative* path (`uploads/…`), not an absolute URL — the BE column is described as a CDN URL and
 * validated with `@IsUrl({ require_tld: false })`, which lets such a path through. So the value read
 * back can be either form, and rendering it raw gives a broken image. The admin module resolves it
 * the same way (`normalizeFloorplanImageUrl`).
 *
 * ⚠️ THE RULE IS NOT THE FLOORPLAN'S — every helix upload column behaves this way, and RES-1316 hit
 * it again on a vendor's `companies.logo_url`. The logic therefore lives in
 * `shared/utils/helix-upload-url` and this is the floorplan's name for it, kept so callers and the
 * admin's matching helper still read alike. `apiUrl` is always passed here because a floorplan can
 * legitimately carry a root-relative path served off the API host.
 *
 * Only the cases a consumer can actually meet are handled — the admin's extra `blob:`/object
 * branches exist for its in-browser upload preview, which this app has no equivalent of.
 */
import { resolveHelixUploadUrl } from 'shared/utils/helix-upload-url';

export const resolveFloorplanImageUrl = (imageUrl: string | undefined | null, apiUrl: string): string =>
  resolveHelixUploadUrl(imageUrl, apiUrl);
